import Verwaltung from "./slides/Verwaltung";
import Vorteile from "./slides/Vorteile";

export default function Messmittel() {
  return [<Verwaltung key="verwaltung2" />, <Vorteile key="vorteile2" />];
}
